// extracted by mini-css-extract-plugin
export default {"chatbotSettingsForm":"chatbotSettings_chatbotSettingsForm__2YOkR"};